import { Injectable } from '@angular/core';
import { Authentication } from '../models/Authentication';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {
  params = JSON.parse(sessionStorage.getItem('getParams'));
  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  /**
   * 
   * @param dataForm get token
   */
  unSubscription(param, captcha) {

    let body;
    if (Array.isArray(param)) {
      body = {
        Channel: param[0],
        Email: param[0] !== 2 ? param[2] : '',
        IdentificationNumber: param[1],
        TyCS: false,
        PolPri: false
      };
      if (param[0] === '2' && param[2] === '') {
        body.CentroId = '0';
      } else if (param[2] !== '') {
        body.CentroId = param[2];
      }
    } else {
      body = {
        Channel: '1',
        Email: param,
        IdentificationNumber: '',
        TyCS: false,
        PolPri: false
      };
    }
    return this.http.post<Authentication>(environment.url + '/Account/Unsubscribe',
      body, { headers: this.headers.set('recaptchaR', captcha) })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  /**
   * devuelde la key del captcha
   */
  getCaptchaKey(codePetition ?: string) {
    const code = codePetition ? '?codepetition=' + codePetition : '';
    return this.http.get(environment.url + '/OnInit' + code).pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }


  /**
   * 
   * @param dataForm get token
   */
  confirmedUnsubscribe(param) {
    return this.http.get<any>(environment.url + '/Account/Confirmedkill/' + param).pipe(retry(1), catchError(this.errorHandl));
  }
}
